import { H1, Loading, PublicLayout, CardContainer } from '@catalyze/ui';
import { useResetPasswordMutation } from 'api/password/resetPassword';
import { ResetForm } from 'features/ResetPassword/components/ResetForm';
import {
    SuccessfullMessage,
    ErrorMessage,
} from 'features/ResetPassword/components/StatusMessage';

import { StyledText } from './styled';

export const ResetPassword = () => {
    const { isError, isSuccess, isIdle, mutate, isLoading } =
        useResetPasswordMutation({});

    return (
        <PublicLayout>
            {isLoading && <Loading />}
            {isError && <ErrorMessage />}
            {isSuccess && <SuccessfullMessage />}
            {isIdle && (
                <CardContainer>
                    <H1>Reset your password</H1>
                    <StyledText>
                        Enter your email and we will send an activation link to
                        your email.
                    </StyledText>
                    <ResetForm onSubmit={(data) => mutate(data)} />
                </CardContainer>
            )}
        </PublicLayout>
    );
};
